export default __webpack_public_path__ + "static/media/30-day-squat.41959fd7.jpeg";